/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  GeneratePtSaftReportParams
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Generate a Portugal SAF-T XML export for the selected PT entity. The response is encoded as windows-1252 for AT/audit compatibility.
 * @summary Generate PT SAF-T report
 */
export type generatePtSaftReportResponse200 = {
  data: Blob
  status: 200
}

export type generatePtSaftReportResponse400 = {
  data: Error
  status: 400
}

export type generatePtSaftReportResponse401 = {
  data: Error
  status: 401
}

export type generatePtSaftReportResponse403 = {
  data: Error
  status: 403
}

export type generatePtSaftReportResponse404 = {
  data: Error
  status: 404
}

export type generatePtSaftReportResponse500 = {
  data: Error
  status: 500
}

export type generatePtSaftReportResponseSuccess = (generatePtSaftReportResponse200) & {
  headers: Headers;
};
export type generatePtSaftReportResponseError = (generatePtSaftReportResponse400 | generatePtSaftReportResponse401 | generatePtSaftReportResponse403 | generatePtSaftReportResponse404 | generatePtSaftReportResponse500) & {
  headers: Headers;
};

export type generatePtSaftReportResponse = (generatePtSaftReportResponseSuccess | generatePtSaftReportResponseError)

export const getGeneratePtSaftReportUrl = (params?: GeneratePtSaftReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/fiscalization/pt/saft/report?${stringifiedParams}` : `/fiscalization/pt/saft/report`
}

export const generatePtSaftReport = async (params?: GeneratePtSaftReportParams, options?: RequestInit): Promise<generatePtSaftReportResponse> => {
  
  return customFetch<generatePtSaftReportResponse>(getGeneratePtSaftReportUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

